export const AUTH_ROUTE_TYPE = 'auth';
export const MAIN_ROUTE_TYPE = 'main';
export const NOTAUTH_ROUTE_TYPE = 'notauth';
export const ONLY_AGENTS_ROUTE_TYPE = 'onlyAgents';
export const ONLY_CLIENTS_ROUTE_TYPE = 'onlyClients';
export const NOT_AGENT_ROUTE_TYPE = 'notAgent';
export const ONLY_AGENTS_AND_NOT_AUTH_CLIENTS = 'onlyAgentsAndNotAuthClients';
